interface IconProps {
  className?: string;
}

const AlignRightIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-4 h-4"}
      {...rest}
    >
      <g clipPath="url(#clip0_12629_159515)">
        <path
          d="M15.984 3.375C15.984 2.96079 15.6482 2.625 15.234 2.625H2.76599C2.35178 2.625 2.01599 2.96079 2.01599 3.375C2.01599 3.78921 2.35178 4.125 2.76599 4.125H15.234C15.6482 4.125 15.984 3.78921 15.984 3.375ZM15.984 14.625C15.984 14.2108 15.6482 13.875 15.234 13.875H7.422C7.00778 13.875 6.672 14.2108 6.672 14.625C6.672 15.0392 7.00778 15.375 7.422 15.375H15.234C15.6482 15.375 15.984 15.0392 15.984 14.625ZM15.984 10.875C15.984 10.4608 15.6482 10.125 15.234 10.125H2.76599C2.35178 10.125 2.01599 10.4608 2.01599 10.875C2.01599 11.2892 2.35178 11.625 2.76599 11.625H15.234C15.6482 11.625 15.984 11.2892 15.984 10.875ZM15.984 7.125C15.984 6.71079 15.6482 6.375 15.234 6.375H7.422C7.00778 6.375 6.672 6.71079 6.672 7.125C6.672 7.53921 7.00778 7.875 7.422 7.875H15.234C15.6482 7.875 15.984 7.53921 15.984 7.125Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_12629_159515">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AlignRightIcon;
